import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { ApplicationSourceDataService } from './../data-services/application-source-data.service';
import { Injectable } from '@angular/core';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';
import * as Enums from './../../../../Autofacets-Core/src/app/utils/enums';

@Injectable({
    providedIn: 'root'
})

export class ApplicationSourceService {
    integrationWithDMS: boolean = false;
    subscription : Subscription;
    constructor(
        private service: ApplicationSourceDataService,
        private secureStorage: SecureStorage,
        private currentLanguageService: CurrentLanguage,
        ) {
    }
    
    async getApplicationSource(): Promise<any> {
        return this.service.GetApplicationSource();
    }

    async getFeatures() {
        let features = this.secureStorage.getKeyData('feature');
        if (features == null || features == undefined) {
          this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
            features = res;
            if (features?.length > 0) {
              this.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
            }
          })
        } else {
          this.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        }
      }
}
